import { render } from "./DaftarPengedalian.vue?vue&type=template&id=735c101e"
import script from "./DaftarPengedalian.vue?vue&type=script&lang=js"
export * from "./DaftarPengedalian.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__